import { render, staticRenderFns } from "./ProdOrderEdit.vue?vue&type=template&id=02345807&"
import script from "./ProdOrderEdit.vue?vue&type=script&lang=js&"
export * from "./ProdOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports